var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Shared helpers for rich automotive custom widgets.
 */
import { buildDialWidget } from '../../primitives/builders';
import { num } from '../../helpers';
import { themeFromProps } from '../../themes';
export function themedDial(app, type, props, max, format, needleKey, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var theme = themeFromProps(props);
    return buildDialWidget(app, type, type, __assign(__assign({}, props), { needleColor: (_a = props.needleColor) !== null && _a !== void 0 ? _a : theme[needleKey] }), {
        max: num(props, 'max', max),
        format: format,
        unit: options.unit,
        tickCount: options.tickCount,
        redlineFrom: options.redlineFrom,
        needleColor: theme[needleKey],
    });
}
